const CLASSES: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  approved: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
  rejected: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
};

const LABELS: Record<string, string> = {
  pending: 'Awaiting approval',
  approved: 'Published',
  rejected: 'Not published',
};

const ReviewStatusBadge = ({ status }: { status?: string }) => {
  const key = status || 'pending';
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${CLASSES[key] || CLASSES.pending}`} data-testid="review-status">
      {LABELS[key] || key}
    </span>
  );
};

export default ReviewStatusBadge;
